<template>
  <div style="text-align: center">
    <!-- <div v-if="isShowImg"></div> -->
    <PosterList
      :currentPage="currentPage"
      :displayImg="displayImg"
      :isShowImg="isShowImg"
      :posterList="posterList"
    />
    <PosterDetail
      :page="currentPage"
      :isShow="dismissSilder"
      :someList="posterList"
      v-if="isShowImg"
    />
  </div>
</template>

<script>
const posterList = [
  {
    src: require('../assets/img/0.jpg'),
  },
  {
    src: require('../assets/img/1.jpg'),
  },
  {
    src: require('../assets/img/2.jpg'),
  },
  {
    src: require('../assets/img/3.jpg'),
  },
  {
    src: require('../assets/img/4.jpg'),
  },
  {
    src: require('../assets/img/5.jpg'),
  },
  {
    src: require('../assets/img/6.jpg'),
  },
];
const one = (resolve) => require(['./posterList'], resolve);
export default {
  components: {
    PosterList: one,
    PosterDetail: (resolve) => require(['./posterDetail'], resolve),
  },
  data() {
    return {
      isDetails: true,
      isShowImg: false,
      currentPage: 0,
      posterList,
    };
  },
  methods: {
    displayImg(numb) {
      this.isShowImg = true;
      this.currentPage = numb;
    },
    dismissSilder() {
      this.isShowImg = false;
      document.body.style.overflow = '';
    },
  },
};
</script>

<style scoped></style>
